import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class CommondashboardService {
  baseproperties: Baseproperties = new Baseproperties();
  private chartInstances: Map<string, Highcharts.Chart> = new Map();
  private baseURL = this.baseproperties.gatewayBaseURL + "/common/commondashboard"

  constructor(private httpClient: HttpClient, private route: Router, public dialogService: DialogService) { }


  getcompliancestatusdata(filterPayload: any): Observable<any> {
    return this.httpClient.post<Observable<any>>(`${this.baseURL}/getcompliancestatusdata`, filterPayload);
  }

  fetchcomplianceconfigurationslist() {
    return this.httpClient.get(`${this.baseURL}/fetchcomplianceconfigurationslist`);
  }

  getuserdashboardconfiguration() {
    return this.httpClient.get(`${this.baseURL}/getuserdashboardconfiguration`);
  }

  getinsuranceapprovalflag() {
    return this.httpClient.get(`${this.baseURL}/getinsuranceapprovalflag`);
  }

  setChartInstance(chartId: string, chart: Highcharts.Chart) {
    this.chartInstances.set(chartId, chart);
  }

  getcompliancedashboardgriddatalist(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/compliancedashboardgriddata`, payload);
  }

  getmultipleflag(payload) {
    return this.httpClient.post(`${this.baseURL}/getmultipleflag`, payload);
  }

  getmultipletaskdata(payload) {
    return this.httpClient.post(`${this.baseURL}/getmultipletaskdata`, payload);
  }

  cu_multiplegetAttachments(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/cu_getAttachments`, payload);
  }

  getRegistrationPiechart(filterPayload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/registrationchartpie`, filterPayload);
  }

  contractpiechart(filterPayload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/contractchartpie`, filterPayload);
  }

  getpoliciescount(filterdata): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getpoliciescount`, filterdata);
  }

  getassessmentPiechart(filterPayload: any): Observable<any> {
    return this.httpClient.post<any>(`${this.baseURL}/hearingpiechart`, filterPayload);
  }

  getauditPiechart(filterPayload: any): Observable<any> {
    return this.httpClient.post<any>(`${this.baseURL}/auditpiechart`, filterPayload);
  }

  getObsStatusChart(): Observable<any> {
    return this.httpClient.get<any>(`${this.baseURL}/obsstatuschart`);
  }

  riskpichart(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/riskpichart`, payload);
  }

  getcasestatuspiechart(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getcasestatuspiechart/`, payload);
  }

  controlledDeletion(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/controlleddeletion`);
  }

  fetchregistrationconfigurations() {
    return this.httpClient.get(`${this.baseURL}/registration/dashboard/fetchregistrationconfigurations`);
  }

  getregistrationchartgriddata(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/registrationchartdata`, payload);
  }

  registrationDataPDF(payload) {
    return this.httpClient.post(`${this.baseURL}/getdashboardpdfdownloaddata`, payload, { responseType: 'blob' });
  }

  getregistrationpdf(id: number): Observable<Blob> {
    return this.httpClient.get(`${this.baseURL}/getregistrationpdf/${id}`, {
      responseType: 'blob',
    });
  }

  registrationsingleDataExcel(licenseid: number): Observable<Blob> {
    return this.httpClient.get(`${this.baseURL}/registrationsingleDataExcel/${licenseid}`, { responseType: 'blob' });
  }

  getRegistrationDataView(licenseid: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/registrationdataview/${licenseid}`);
  }

  getRiskreportData(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getriskreport`, payload);
  }

  getuserxproduct() {
    return this.httpClient.get(`${this.baseURL}/getuserxproduct`);
  }

  getdashboardCounts() {
    return this.httpClient.get(`${this.baseURL}/getdashboardCounts`);
  }

  getnoticestatuswisebarchart(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/getnoticestatuswisebarchart`, payload);
  }

}
